(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ur-gallery-context"] && !Shopify.designMode) return;
  try {
    (() => {
    const managedLinks = new WeakMap();
    const isAudience = value => value === 'men' || value === 'women';
    const isProduct = url => url.origin === location.origin && url.pathname.includes('/products/');

    function audience() {
      const url = new URL(location.href);
      if (isProduct(url)) {
        const view = url.searchParams.has('view') ? url.searchParams.get('view') : document.querySelector('[data-ur-gallery-template]')?.dataset.urGalleryTemplate;
        return isAudience(view) ? view : '';
      }
      const legacy = url.searchParams.get('ur_audience');
      if (['men', 'women', 'all'].includes(legacy)) return isAudience(legacy) ? legacy : '';
      const key = 'filter.v.t.shopify.target-gender';
      if (url.searchParams.has(key)) {
        const values = url.searchParams.getAll(key).flatMap(value => value.split(','));
        const men = values.includes('gid://shopify/TaxonomyValue/19');
        const women = values.includes('gid://shopify/TaxonomyValue/18');
        return men !== women ? (men ? 'men' : 'women') : '';
      }
      const handle = url.pathname.split('/collections/')[1]?.split('/')[0] || '';
      if (handle === 'all-womens' || handle.startsWith('women')) return 'women';
      if (handle === 'all-mens' || handle.startsWith('men')) return 'men';
      return '';
    }

    function sourceView(source) {
      if (source?.dataset?.urGalleryView !== undefined) return source.dataset.urGalleryView;
      const href = source?.getAttribute?.('href');
      if (href) {
        let url;
        try { url = new URL(href, location.origin); } catch { return audience(); }
        if (url.searchParams.has('view')) return url.searchParams.get('view');
      }
      const productInfo = source?.closest?.('product-info');
      if (productInfo?.dataset.urGalleryView !== undefined) return productInfo.dataset.urGalleryView;
      return audience();
    }

    function withView(value, source) {
      let url;
      try { url = new URL(value, location.origin); } catch { return value; }
      if (!isProduct(url) || url.searchParams.has('view')) return value;
      const view = sourceView(source);
      if (!view) return value;
      url.searchParams.set('view', view);
      return url.toString();
    }

    function updateLink(link) {
      if (!link.matches('a[href]')) return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      let url;
      try { url = new URL(href, location.origin); } catch { return; }
      if (!isProduct(url)) return;
      const managed = managedLinks.get(link);
      if (url.searchParams.has('view') && (!managed || url.searchParams.get('view') !== managed)) {
        managedLinks.delete(link);
        return;
      }
      const view = audience();
      if (view) {
        url.searchParams.set('view', view);
        managedLinks.set(link, view);
      } else {
        if (!managed) return;
        url.searchParams.delete('view');
        managedLinks.delete(link);
      }
      if (url.href !== link.href) link.href = url.href;
    }

    function updateLinks(root) {
      if (root.matches?.('a[href]')) updateLink(root);
      root.querySelectorAll?.('a[href]').forEach(updateLink);
    }

    function refresh() {
      const marker = document.querySelector('[data-ur-gallery-context]');
      if (marker) marker.dataset.urGalleryContext = audience();
      updateLinks(document);
    }

    window.URGalleryContext = { url: withView };

    const installProductInfo = () => {
      const prototype = customElements.get('product-info').prototype;
      if (prototype.urGalleryContextInstalled) return;
      prototype.urGalleryContextInstalled = true;
      const buildRequest = prototype.buildRequestUrlWithParams;
      prototype.buildRequestUrlWithParams = function(...args) {
        return withView(buildRequest.apply(this, args), this);
      };
      const updateURL = prototype.updateURL;
      prototype.updateURL = function(...args) {
        const result = updateURL.apply(this, args);
        if (this.dataset.updateUrl === 'false') return result;
        const url = withView(location.href, this);
        if (url !== location.href) {
          history.replaceState(history.state, '', url);
          this.shareButton?.updateUrl(url);
        }
        return result;
      };
    };
    if (customElements.get('product-info')) installProductInfo();
    else customElements.whenDefined('product-info').then(installProductInfo);

    const start = () => {
      refresh();
      new MutationObserver(records => {
        records.forEach(record => {
          if (record.type === 'attributes') updateLink(record.target);
          else record.addedNodes.forEach(updateLinks);
        });
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    ['click', 'auxclick', 'contextmenu', 'pointerdown', 'focusin'].forEach(type => {
      document.addEventListener(type, event => {
        const link = event.target.closest?.('a[href]');
        if (link) updateLink(link);
      }, true);
    });
    window.addEventListener('pageshow', refresh);
    window.addEventListener('popstate', refresh);
    document.addEventListener('shopify:section:load', refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
